var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgE2Playroom(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38 3.63L3 25.89V69h70V25.9L38 3.63zM69 65H7V28.08L38 8l31 20.08V65zM51.26 49.23a4 4 0 110 8 4 4 0 010-8zM37.91 23.91a11.37 11.37 0 0112.17 12.16 14.47 14.47 0 01-8.57 12.25L25.67 32.48a14.47 14.47 0 0112.24-8.57zM24.72 35.57l13.7 13.7c-5.21.75-7.56-2.3-10.19.33l-8 8-3.83-3.83 8-8c2.6-2.64-.4-4.99.32-10.2z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/E2_Playroom.e0e13d40.svg";
export { SvgE2Playroom as ReactComponent };